module.exports = __webpack_public_path__ + "img/user.9726c059.svg";